module.exports = __webpack_public_path__ + "img/0S6A9336.0bd1ec33.jpg";